module.exports = __webpack_public_path__ + "img/profile-banner.0ff4c43d.jpg";